export interface StoredRead<T> {
  value: T;
  /** True when stored data existed but was discarded because it was unreadable. */
  discarded: boolean;
}

export const hasStorage = (): boolean => {
  try {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  } catch {
    return false;
  }
};

export const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const readLocalJson = (key: string): StoredRead<unknown> => {
  if (!hasStorage()) {
    return { value: null, discarded: false };
  }

  try {
    const raw = window.localStorage.getItem(key);
    if (!raw) {
      return { value: null, discarded: false };
    }
    return { value: JSON.parse(raw), discarded: false };
  } catch {
    return { value: null, discarded: true };
  }
};

export const writeLocalJson = (key: string, value: unknown): boolean => {
  try {
    if (!hasStorage()) return false;
    window.localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch {
    return false;
  }
};
